import { Component, OnInit } from '@angular/core';
import { AdminServiceService } from '../../service/admin-service.service';
import { UiService } from '../../service/ui.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
})
export class TermsComponent implements OnInit {
  public terms = '';
  public termId: number = undefined;
  public type = '';
  private _termsData: any[] = [];

  constructor(
    private adminSv: AdminServiceService,
    private uiSv: UiService
  ) { }

  async ngOnInit() {
    this._termsData = await this.adminSv.getTerms();
    const term = this._termsData.find(x => x.id === 1);
    this.termId = 1;
    this.terms = term.description || '';
  }

  async postTerms(){
    try{
      await this.uiSv.presentLoader('Guardando');
      const action = this.termId ? 'update' : 'create';
      const body = {
        name: 'terminos',
        description: this.terms,
        orden: '1',
        id: this.termId
      }
      const res = await this.adminSv.postTerms(action, body);
      if(res.status){
        this.uiSv.showToast('Guardado exitosamente');
      }
      await this.uiSv.loading.dismiss();
    }catch(err){
      await this.uiSv.loading.dismiss();
      console.error(err);
    }
  }

  changeTerm(){
    const term = this._termsData.find(x => x.id === this.termId);
    this.terms = term?.description || '';
  }

}
